import { Controller } from "@hotwired/stimulus"

// Generic slide-toggle: click the button target, jQuery-slideToggle the
// panel target, rotate the arrow target. Written with no tag/customer
// knowledge so it's a drop-in for customer_orders/screener's tag panel
// today and vendor_customers/show's #toggleCustomerDetails panel later --
// same interaction, different content.
export default class extends Controller {
  static targets = ["button", "arrow", "panel"]

  toggle() {
    const expanded = this.buttonTarget.getAttribute("aria-expanded") === "true"

    $(this.panelTarget).slideToggle(400)
    this.arrowTarget.classList.toggle("rotate-90")
    this.buttonTarget.setAttribute("aria-expanded", String(!expanded))
  }
}
